/*
 * @Descripttion:
 * @Author: Junteng Shi
 * @Date: 2025-03-27 15:24:37
 * @LastEditors: HongJian Liu
 * @LastEditTime: 2025-08-06 14:52:00
 */
import { get, post } from '@/utils/http/axios';
import request from '@/utils/http/axios/index';

enum URL {
  menulist = '/pbl/sys/menu/list',
  areas = '/pbl/common/getTreeArea',
  reset = '/pbl/common/resetPassword',
  yearsClass = '/pbl/common/getClassByEnrollmentYear',
  disDict = '/pbl/common/subjectEnums',
  subjectEnums = '/pbl/common/subjectEnums',
  newAllArea = '/pbl/common/sift/getTreeArea',
  phoneCode = '/pbl/common/send-reset-code',
  resetPassword = '/pbl/common/reset-password',
  captcha = '/pbl/generate',
}
export const getMenuList = async () =>
  get<any>({
    url: URL.menulist,
    params: { system: 4 },
  });

/** 获取所有地区 */
export const getAllAreas = async () =>
  get<any>({
    url: URL.areas,
  });

/*** 获取所有地区 */
export const getNewAllAreas = async () =>
  get<any>({
    url: URL.newAllArea,
  });

/** 重置密码 */
export const resetPassword = async (data: any) =>
  get<any>({
    url: URL.reset,
    params: data,
  });

/** 根据学级查询班级 */
export const searchsClass = async (data: any) =>
  get<any>({
    url: URL.yearsClass,
    params: data,
  });

/** 获取字典列表 */
export const getDisDict = async () =>
  get<any>({
    url: URL.disDict,
  });

/** 获取学科 */
export const getAllSubject = async () =>
  get<any>({
    url: URL.subjectEnums,
  });

/**
 * 文件导出
 * @returns {Promise<any>} Promise对象
 */
export function fileDownFun(url: string, data: any) {
  /*get请求*/
  return request({
    url: url,
    method: 'get',
    params: data,
    timeout: 120 * 1000,
    responseType: 'blob' /*下载文件必填项*/,
  }).then((res) => res);
}
export const getPhoneCode = async (data) =>
  post<any>({
    url: URL.phoneCode,
    data,
  });
export const getResetPassword = async (data) =>
  post<any>({
    url: URL.resetPassword,
    data,
  });

export const getCaptcha = async (params) =>
  get<any>({
    url: URL.captcha,
    params,
    responseType: 'arraybuffer',
  });
